import * as React from 'react';
import Layout from 'core/components/Layout';
import SEO from 'core/components/SEO';
import GenericPage from 'core/components/GenericPage';
import {
    GenericPageData,
    OgImageQuery,
    PageContextWithMetaData,
} from 'lib/types';
import pageDefaults from 'data/pageDefaults/termsOfUse';
import { graphql, PageProps } from 'gatsby';
import parse from 'html-react-parser';

type TermsOfUseQuery = OgImageQuery & {
    page: {
        title: string;
        description: string;
        pageData: GenericPageData;
    };
};

export const query = graphql`
    query TermsOfUseQuery($ogImage: String) {
        ogImage: upload(imageId: { eq: $ogImage }) {
            ...OgImage
        }
        page(slug: { eq: "terms-of-use" }) {
            title
            description
            pageData
        }
    }
`;

export default function TermsOfUsePage({
    data: { ogImage, page },
    location: { pathname },
    pageContext,
}: PageProps<TermsOfUseQuery, PageContextWithMetaData>) {
    const pageData = { ...pageDefaults, ...page?.pageData };

    return (
        <Layout>
            <SEO
                title={page?.title ?? pageContext.title}
                description={page?.description ?? pageContext.description}
                pathname={pathname}
                ogImage={ogImage}
            />
            <GenericPage title={pageData.title} noCtaFooter>
                {parse(pageData.content)}
            </GenericPage>
        </Layout>
    );
}
